export default "__VITE_PUBLIC_ASSET__fc735e52__"